import {
    Button,
    ButtonProps,
    createPolymorphicComponent,
    Text,
} from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
interface MyComponentProps extends ButtonProps {
    label: string
}

const _TableAddNewButton = ({
    label,
    classNames,
    styles,
    unstyled,
    className,
    ...others
}: MyComponentProps) => {
    return (
        <Button
            className={className}
            px='xs'
            color='green'
            h={'38px'}
            mt='auto'
            radius='10px'
            {...others}
        >
            <IconPlus size={'1.2rem'} />
            <Text ml='5px'>{label}</Text>
        </Button>
    )
}

const TableAddNewButton = createPolymorphicComponent<
    'button',
    MyComponentProps
>(_TableAddNewButton)
export default TableAddNewButton
